import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { type CSSProperties, type FC, useState } from 'react';
import { Modal, Button as RawButton } from 'react-bootstrap';
import { NotificationBadge } from '../BasicComponents/NotificatioBadge/NotificationBadge';

interface Props {
  title?: string;
  buttonIcon: React.ReactNode;
  children: React.ReactNode;
  style?: CSSProperties;
  activ?: boolean;
}

export const BasicModal: FC<Props> = ({
  title = '',
  buttonIcon,
  children,
  style = {},
  activ = false,
}) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div>
      <NotificationBadge show={activ}>
        <Button
          onClick={showModal}
          style={style}
          size="sm"
          activ={activ ? 'true' : 'false'}
          variant="outline-secondary"
        >
          {buttonIcon}
        </Button>
      </NotificationBadge>
      <Modal show={visible} onHide={handleCancel} footer={null}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <RawButton variant="secondary" onClick={handleCancel}>
            Close
          </RawButton>
          <RawButton variant="primary" onClick={handleOk}>
            Ok
          </RawButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const Button = styled(RawButton)<{ activ: 'false' | 'true' }>`
  border-radius: 5px;
  ${({ activ }) =>
    activ === 'true'
      ? `
  box-shadow: 0px 0px 5px 2px ${RacemapColors.PaleBlue};
  border-color: ${RacemapColors.PaleBlue};
  `
      : ''}
`;
